import React, { useContext, useEffect, useState } from "react";
import MobileNavbar from "./Navbar/MobileNavbar";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { HeaderContext } from "../context/HeaderContext";

const Navbar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { imageUrl, heroes } = useContext(HeaderContext);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const links = [
    { name: "Home", path: "/" },
    { name: "Blogs", path: "/blog" },
    { name: "All Courses", path: "/courses" },
    { name: "My Services", path: "/services" },
    { name: "Memberships", path: "/memberships" },
    { name: "About Me", path: "/about" },
    // { name: "Instructors", path: "/instructors" },
    { name: "Contact", path: "/contact" },
  ];

  return (
    <>
    <motion.nav 
      className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? "py-2 bg-gray-900/95 backdrop-blur-md shadow-xl" : "py-4 bg-gray-900/80 backdrop-blur-sm"}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container mx-auto px-4 flex items-center justify-between">
        {/* Logo with animation */}
        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="flex items-center"
        >
          <Link to="/" className="text-lg no-underline font-bold text-white">
            {heroes.logo ? (
              <img 
                src={`${imageUrl}/${heroes.logo}`} 
                alt="Logo" 
                className={`transition-all duration-300 ${scrolled ? "h-8" : "h-10"}`} 
              />
            ) : (
              <motion.h2 
                className="bg-gradient-to-r from-green-400 to-green-600 bg-clip-text text-transparent"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.2 }}
              >
                SkillForge
              </motion.h2>
            )}
          </Link>
        </motion.div>

        {/* Menu Items for Desktop */}
        <div className="hidden lg:flex lg:items-center lg:space-x-6">
          {links.map((link, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <Link
                to={link.path}
                className={`relative text-gray-200 hover:text-white no-underline py-2 transition-colors duration-300 ${
                  location.pathname === link.path 
                    ? "text-green-400 font-medium" 
                    : ""
                }`}
              >
                {link.name}
                {location.pathname === link.path && (
                  <motion.span 
                    className="absolute bottom-0 left-0 w-full h-0.5 bg-green-400"
                    layoutId="navUnderline"
                    transition={{ type: "spring", bounce: 0.25, duration: 0.5 }}
                  />
                )}
              </Link>
            </motion.div>
          ))}
        </div>

        {/* CTA Button */}
        <motion.div 
          className="hidden lg:block"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <Link
            to="/contact"
            className="bg-gradient-to-r from-green-500 to-green-600 text-white font-medium py-2 px-6 rounded-full shadow-lg hover:shadow-green-500/20 transition-all duration-300"
          >
            Get Started
          </Link>
        </motion.div>

        {/* Hamburger Icon for Mobile */}
        <motion.div 
          className="lg:hidden z-50"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          <button 
            onClick={toggleMenu} 
            className="text-white focus:outline-none p-2 rounded-full bg-gray-800/50 hover:bg-gray-700/50 transition-colors duration-300"
            aria-label="Toggle menu"
          >
            {isOpen ? (
              <FaTimes size={24} className="text-green-400" />
            ) : (
              <FaBars size={24} />
            )}
          </button>
        </motion.div>

        {/* Mobile Menu Overlay */}
        {isOpen && (
          <motion.div 
            className="fixed inset-0 bg-gray-900/95 backdrop-blur-lg z-40 lg:hidden"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <MobileNavbar 
              links={links} 
              currentPath={location.pathname}
              toggleMenu={toggleMenu} 
            />
          </motion.div>
        )}
      </div>
    </motion.nav>

    {isOpen && (
      <MobileNavbar 
        links={links} 
        currentPath={location.pathname}
        toggleMenu={toggleMenu} 
      />
    )}

    </>
  );
};

export default Navbar;